<template>
  <div class="page-error flex-container flex-row flex-horiz-center">
    <div class="main flex-container flex-column flex-verti-center">
      <img class="empty-pic" :src="require('@/assets/image/pic_404.png')" alt="">
      <div class="info">
        <span>{{`你访问的页面不存在，${leftSeconds}s后`}}</span>
        <router-link :to="{name:'Index'}">返回首页</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',
  mounted() {
    this.counter()
  },
  data() {
    return {
      leftSeconds: 5,
      interval: null
    }
  },
  methods: {
    counter() {
      if (this.leftSeconds > 0) {
        this.interval = setTimeout(() => {
          this.leftSeconds--
          this.counter()
        }, 1000)
      } else {
        clearInterval(this.interval)
        this.$router.replace({
          name: 'Index'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-error{
  height: 100%;
  .empty-pic{
    width: 300px;
    height:300px;
  }
  .info{
    text-align: center;
    >a{
      padding-left: 4px;
      text-decoration: none;
      color: @theme-color;
    }
  }
}

</style>
